import { render, staticRenderFns } from "./roi.drawer.vue?vue&type=template&id=7f523d68&"
import script from "./roi.drawer.vue?vue&type=script&lang=js&"
export * from "./roi.drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports